import ConstructionIcon from "@mui/icons-material/Construction";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import Box from "@mui/material/Box";
import { amber } from "@mui/material/colors";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

export const templateSystemColor = amber[500];

const TemplateSystemIcon = () => {
  const { t } = useTranslation(["glossary"]);

  return (
    <Tooltip title={t("glossary:template")}>
      <Box
        component="span"
        sx={{
          position: "relative",
          display: "inline-flex",
          width: 20,
          height: 20,
          ml: 1,
          verticalAlign: "middle",
          color: templateSystemColor,
        }}
      >
        <RadioButtonUncheckedIcon fontSize="small" sx={{ position: "absolute", top: 0, left: 0 }} />
        <ConstructionIcon sx={{ position: "absolute", top: 4, left: 4, fontSize: 12 }} />
      </Box>
    </Tooltip>
  );
};

export default TemplateSystemIcon;
